import { GET_IMPORT_DATA_STATUS_LIST, GET_IMPORT_DATA_STATUS_LIST_ERROR, GET_IMPORT_LOG_BY_REFNUM, GET_IMPORT_LOG_BY_REFNUM_ERROR, GET_IMPORT_LOG_STATUS_LIST, GET_IMPORT_LOG_STATUS_LIST_ERROR, GET_IMPORT_LOGS_LIST, GET_IMPORT_LOGS_LIST_ERROR, RESET_IMPORTLOG_DETAIL } from "../../actions/types"

const initialState = {
    importLogList: [],
    importStatusList: [],
    importResultData: {},
    importResultStatus: [],
}
export default function importLog(state = initialState, action) {

    switch (action.type) {
        case GET_IMPORT_LOGS_LIST:
            return {
                ...state,
                importLogList: action.payload.data
            }
        case GET_IMPORT_LOGS_LIST_ERROR:
            return {
                ...state,
                importLogList: []
            }
        case GET_IMPORT_LOG_STATUS_LIST:
            return {
                ...state,
                importStatusList: action.payload.data
            }
        case GET_IMPORT_LOG_STATUS_LIST_ERROR:
            return {
                ...state,
                importStatusList: []
            }

        case GET_IMPORT_LOG_BY_REFNUM:
            return {
                ...state,
                importResultData: action.payload.data
            }
        case GET_IMPORT_LOG_BY_REFNUM_ERROR:
            return {
                ...state,
                importResultData: []
            }
        case RESET_IMPORTLOG_DETAIL:
            return {
                ...state,
                importResultData: []
            }

        case GET_IMPORT_DATA_STATUS_LIST:
            return {
                ...state,
                importResultStatus: action.payload.data
            }
        case GET_IMPORT_DATA_STATUS_LIST_ERROR: 
            return {
                ...state,
                importResultStatus: []
            } 

        default:
            return { ...state }
    }
}